import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 16.5a3.75 3.75 0 113.75 3.75H6a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 009 9.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.223 6.325c0-.65.134-1.27.374-1.833.19-.444-.27-.907-.7-.685a4.342 4.342 0 00-2.293 4.531c.286 1.89 1.864 3.407 3.763 3.631a4.347 4.347 0 002.069-.253c.448-.17.404-.819-.05-.973a4.669 4.669 0 01-3.163-4.418z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 16.5a3.75 3.75 0 113.75 3.75H6a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 009 9.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.223 6.325c0-.65.134-1.27.374-1.833.19-.444-.27-.907-.7-.685a4.342 4.342 0 00-2.293 4.531c.286 1.89 1.864 3.407 3.763 3.631a4.347 4.347 0 002.069-.253c.448-.17.404-.819-.05-.973a4.669 4.669 0 01-3.163-4.418z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 33a7.5 7.5 0 117.5 7.5H12a7.5 7.5 0 010-15M10.5 27a7.5 7.5 0 0112-6m.658.555A7.472 7.472 0 0018 19.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36.445 12.65c0-1.302.268-2.542.748-3.666.38-.888-.54-1.814-1.398-1.37a8.683 8.683 0 00-4.588 9.062c.572 3.78 3.728 6.814 7.526 7.262a8.693 8.693 0 004.138-.506c.896-.342.808-1.638-.1-1.946-3.678-1.254-6.326-4.732-6.326-8.836z",
    clipRule: "evenodd"
  }))
};
export var WeatherNightOvercast = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});